import React, { useContext } from "react";

import AnswersContext from "../contexts/AnswersContext";
import useQuestion from "../hooks/useQuestion";

const AnswerBadge = ({ questionID, answerID, showAnswers }) => {
  const { getAnswer } = useContext(AnswersContext);
  const { question } = useQuestion({ questionID });
  const answer = getAnswer(questionID);
  const correctAnswer = question.answer;

  const hasCorrectAnswer = answer && answerID === correctAnswer && showAnswers;
  const hasIncorrectAnswer =
    answer && answer === answerID && answer !== correctAnswer && showAnswers;
  const hasAnsweredAnswer = answer && answer === answerID && !showAnswers;

  return (
    <>
      {hasCorrectAnswer && (
        <span
          aria-label="Correct answer."
          className="badge bg-success float-end font-monospace"
        >
          &#x2714;&#xFE0E;
        </span>
      )}
      {hasIncorrectAnswer && (
        <span
          aria-label="Incorrect answer."
          className="badge bg-danger float-end font-monospace"
        >
          &#x2718;&#xFE0E;
        </span>
      )}
      {hasAnsweredAnswer && (
        <span
          aria-label="Selected answer."
          className="badge bg-primary float-end font-monospace"
        >
          &mdash;&#xFE0E;
        </span>
      )}
    </>
  );
};

export default AnswerBadge;
